import { LinkTo } from "@ember/routing";
import MobileNav from "discourse/components/mobile-nav";
import PluginOutlet from "discourse/components/plugin-outlet";
import dIcon from "discourse/helpers/d-icon";
import lazyHash from "discourse/helpers/lazy-hash";

const CirclesViewNavigationTabs = <template>
  <PluginOutlet
    @name="circles-view-navigation-tabs"
    @outletArgs={{lazyHash model=@model tabs=@tabs}}
  >
    <MobileNav @desktopClass="nav nav-pills" class="circles-nav">
      {{#each @tabs as |tab|}}
        <PluginOutlet
          @name="circles-view-navigation-tab-item"
          @outletArgs={{lazyHash model=@model tab=@tab tabs=@tabs}}
        >
          <Tab @tab={{tab}} @model={{@model}} />
        </PluginOutlet>
      {{/each}}
    </MobileNav>
  </PluginOutlet>
</template>;

export const Tab = <template>
  <li
    class={{if @tab.options.showNotification "circles-show-notification"}}
    data-tab-name={{@tab.name}}
  >
    <LinkTo
      @route={{@tab.route}}
      @model={{@model}}
      title={{@tab.title}}
      class="circles-tab-{{@tab.name}}"
    >
      {{#if @tab.icon}}{{dIcon @tab.icon}}{{/if}}
      <span class="circles-nav-title">{{@tab.title}}</span>
      {{#if @tab.options.count}}
        <span class="circles-nav-count">{{@tab.options.count}}</span>
      {{/if}}
    </LinkTo>
  </li>
</template>;

export default CirclesViewNavigationTabs;
